import { Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const PublicationStatus = ({ open }) => {
  const { t } = useTranslation()

  return (
    <Tooltip
      defaultOpen={open}
      className="publication-status"
      placement="left"
      title={t('Header.Preparing')}
      style={{ textAlign: 'right' }}
    >
      <img src="images/contract/success.svg" alt="publication-status" />
    </Tooltip>
  )
}

export default PublicationStatus
